// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CrawlerTypeSchema = z.enum(['SHALLOW','AI','MANUAL','AUTHENTICATION','FEATURE_ANALYSIS','NAVIGATION_PROFILE'] as const);

export type CrawlerTypeType = `${z.infer<typeof CrawlerTypeSchema>}`

export default CrawlerTypeSchema;
